
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../BaseUrl";
import { toastError, toastSuccess } from "../../AlertMessage/AlertMessage";

// Get Table Data
export const DefineProjectwisestateareaTableDataAPI = createAsyncThunk("DefineProjectwisestateareaTableData", async ({ data }) => {
    const {
        M_ProjectID,
        M_StateNameID,
        M_RegionalOfficeID,
        M_FieldStationOfficerID,
        M_DistrictNameID,
        M_TableUserMasterID,
        Flag,
        FromTop,
        ToTop,
        token
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Master/Get_Web_M_ProjectArea_Select?M_ProjectID=${M_ProjectID}&M_StateNameID=${M_StateNameID}&M_RegionalOfficeID=${M_RegionalOfficeID}&M_FieldStationOfficerID=${M_FieldStationOfficerID}&M_DistrictNameID=${M_DistrictNameID}&M_TableUserMasterID=${M_TableUserMasterID}&Flag=${Flag} &FromTop=${FromTop}&ToTop=${ToTop}`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                if (result.data) {
                    return result.data
                } else {
                    return result
                }
            } else {
                toastError(result.message)
                return result
            }
        })
})

const DefineProjectwisestateareaTableDataSlice = createSlice({
    name: "DefineProjectwisestateareaTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(DefineProjectwisestateareaTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(DefineProjectwisestateareaTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(DefineProjectwisestateareaTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const DefineProjectwisestateareaTableDataReducer = DefineProjectwisestateareaTableDataSlice.reducer


//  Insert Table Data

export const DefineProjectwisestateareaPostAPI = createAsyncThunk("DefineProjectwisestateareaPost", async ({ data }) => {
    const {
        M_ProjectAreaID,
        M_ProjectID,
        M_StateID,
        M_RegionalOfficeID,
        M_FieldStationOfficerID,
        M_DistrictID,
        ProjectArea,
        M_UnitID,
        M_TableUserMasterID,
        Flag,
        token,
        handleIsPost,
        RawData
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_ProjectID", M_ProjectID);
    formdata.append("RawData", RawData);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Master/Post_Web_M_ProjectArea_Insert`, requestOptions)

        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.status) {
                { (result.code >= 200 && result.code <= 300) && handleIsPost() }
                toastSuccess(result.message)
            } else {
                toastError(result.message)
            }
            return result
        })
})

const DefineProjectwisestateareaPostSlice = createSlice({
    name: "DefineProjectwisestateareaPost",
    initialState: {
        isPostLoading: false,
        Data: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(DefineProjectwisestateareaPostAPI.pending, (state, action) => {
            state.isPostLoading = true;
        });
        builder.addCase(DefineProjectwisestateareaPostAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.CropNametableData = action.payload;
        });
        builder.addCase(DefineProjectwisestateareaPostAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading = false;
            state.isError = true;
            state.CropNametableData = null;

        });
    },
})

export const DefineProjectwisestateareaPostReducer = DefineProjectwisestateareaPostSlice.reducer


// Insert Post API

export const DefineProjectwisestateareaPatchAPI = createAsyncThunk("DefineProjectwisestateareaPatch", async ({ data }) => {
    const {
        M_ProjectAreaID,
        M_ProjectID,
        M_StateID,
        M_RegionalOfficeID,
        M_FieldStationOfficerID,
        M_DistrictID,
        ProjectArea,
        M_UnitID,
        M_TableUserMasterID,
        Flag,
        token,
        handleIsPost
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();

    formdata.append("M_ProjectAreaID", M_ProjectAreaID);
    formdata.append("M_ProjectID", M_ProjectID);
    formdata.append("M_StateID", M_StateID);
    formdata.append("M_RegionalOfficeID", M_RegionalOfficeID);
    formdata.append("M_FieldStationOfficerID", M_FieldStationOfficerID);
    formdata.append("M_DistrictID", M_DistrictID);
    formdata.append("ProjectArea", ProjectArea);
    formdata.append("M_UnitID", M_UnitID);
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);

    const requestOptions = {
        method: "PATCH",
        headers: myHeaders,
        body: formdata,
        redirect: "follow"
    };

    fetch(`${BaseUrl}/Master/Web_M_ProjectArea_Update`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.status) {
                { (result.code >= 200 && result.code <= 300) && handleIsPost() }
                toastSuccess(result.message)
            } else {
                toastError(result.message)
            }
            return result
        })
})

const DefineProjectwisestateareaPatchSlice = createSlice({
    name: "DefineProjectwisestateareaPost",
    initialState: {
        isPostLoading: false,
        Data: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(DefineProjectwisestateareaPatchAPI.pending, (state, action) => {
            state.isPostLoading = true;
        });
        builder.addCase(DefineProjectwisestateareaPatchAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.CropNametableData = action.payload;
        });
        builder.addCase(DefineProjectwisestateareaPatchAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading = false;
            state.isError = true;
            state.CropNametableData = null;

        });
    },
})

export const DefineProjectwisestateareaPatchReducer = DefineProjectwisestateareaPatchSlice.reducer



export const DefineProjectwisestateareaDeleteAPI = createAsyncThunk("DefineProjectwisestateareaDelete", async ({ data }) => {
    const {
        M_DepartmentNameMasterID,
        DepartmentName,
        DepartmentCode,
        UserID,
        Flag,
        token,
        handleIsPost
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_DepartmentNameMasterID", M_DepartmentNameMasterID);
    formdata.append("M_OfficeMasterID", "1");
    formdata.append("DepartmentName", DepartmentName);
    formdata.append("DepartmentCode", DepartmentCode);
    formdata.append("UserID", UserID);
    formdata.append("Flag", Flag);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata
    };

    fetch(`${BaseUrl}/EMS/Master/Post_M_DepartmentNameMasterInsertUpdateDelete`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.status) {
                { (result.code >= 200 && result.code <= 300) && handleIsPost() }
                toastSuccess(result.message)
            } else {
                toastError(result.message)
            }
            return result
        })
})

const DefineProjectwisestateareaDeleteSlice = createSlice({
    name: "DefineProjectwisestateareaDelete",
    initialState: {
        isDeleteLoading: false,
        DeleteData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(DefineProjectwisestateareaDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(DefineProjectwisestateareaDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.DeleteData = action.payload;
        });
        builder.addCase(DefineProjectwisestateareaDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.DeleteData = null;

        });
    },
})

export const DefineProjectwisestateareaDeleteReducer = DefineProjectwisestateareaDeleteSlice.reducer


// Delete API On popup
export const DefineProjectwisestateareaPopUpDeleteAPI = createAsyncThunk("DefineProjectwisestateareaPopUpDelete", async ({ data }) => {
    const {
        M_ProjectAreaID,
        token,
        handleIsPost,
        handleShowDelete
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    const formdata = new FormData();
    formdata.append("M_ProjectAreaID",M_ProjectAreaID);

    const requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      body: formdata,
      redirect: "follow"
    };
    
    fetch(`${BaseUrl}/Master/Web_M_ProjectArea_Delete`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if ((result.code >= 200 && result.code <= 300) && result.status) {
                // console.log(result.message)
                toastSuccess(result.message)
                handleIsPost()
                handleShowDelete()
            } else {
                toastError(result.message)
            }
            return result
        })
})

const DefineProjectwisestateareaPopUpDeleteSlice = createSlice({
    name: "DefineProjectwisestateareaPopUpDelete",
    initialState: {
        isDeleteLoading: false,
        DeleteData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(DefineProjectwisestateareaPopUpDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(DefineProjectwisestateareaPopUpDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.DeleteData = action.payload;
        });
        builder.addCase(DefineProjectwisestateareaPopUpDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.DeleteData = null;

        });
    },
})

export const DefineProjectwisestateareaPopUpDeleteReducer = DefineProjectwisestateareaPopUpDeleteSlice.reducer